<mat-expansion-panel
  hideToggle
  #xp
  [expanded]="expanded"
  (expandedChange)="onExpandedChange()"
>
  <mat-expansion-panel-header [ngClass]="theme == 'pink' ? 'header-pink' : ''">
    <div class="padre">
      <mat-panel-title class="colap-title" style="align-self: center">
        {{ title }}
        &nbsp;
        <svg-icon
          *ngIf="mostrarInfo"
          class="icon"
          app-tooltip="{{ info }}"
          position="right"
          src="../../assets/icons/information-right-white.svg"
          [svgStyle]="{
            'width.rem': 0.93,
            'height.rem': 0.87,
            position: 'relative',
            'left.rem': 0.15
          }"
        ></svg-icon>
      </mat-panel-title>
      <mat-panel-description class="colap-description">
        <ng-content select="[description]"></ng-content>
      </mat-panel-description>
      <div style="align-self: center;" class="colap-icon">
        <mat-icon *ngIf="!xp.expanded" class="expand-active"
          >add_circle_outline</mat-icon
        >
        <mat-icon *ngIf="xp.expanded" class="expand-inactive"
          >remove_circle_outline</mat-icon
        >
      </div>
    </div>
  </mat-expansion-panel-header>
  <div class="padding">
    <ng-content select="[body]"></ng-content>
  </div>
</mat-expansion-panel>
